import React from 'react';
import PropTypes from 'prop-types';
import { TEXT_LABELS } from '../constants/TextLabelConstants';
import { FONTS } from '../constants/Fonts';

const EmptyRoom = ({ tone = 'light' }) => {
  const color = tone === 'dark' ? '#003' : '#FFFFFF';

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        minHeight: 160,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '24px 16px',
        boxSizing: 'border-box',
      }}
    >
      <p
        style={{
          margin: 0,
          fontFamily: FONTS.INTER_BOLD,
          fontWeight: 700,
          fontSize: 20,
          lineHeight: '32px',
          letterSpacing: 0.8,
          color,
        }}
      >
        {TEXT_LABELS.RAP_HOUSIE_CREATED_ROOM_NO_LIST_TITLE}
      </p>
      <p
        style={{
          margin: '5px 0 0',
          fontFamily: FONTS.INTER_REGULAR,
          fontWeight: 400,
          fontSize: 12,
          lineHeight: '20px',
          letterSpacing: 0.8,
          color,
        }}
      >
        {TEXT_LABELS.RAP_HOUSIE_CREATED_ROOM_NO_LIST_SUBTITLE}
      </p>
    </div>
  );
};

EmptyRoom.propTypes = {
  tone: PropTypes.oneOf(['light', 'dark']),
};

export default EmptyRoom;
